<template>
    <div>
        <!--頁首-->
        <Header :header="header"></Header>
        <!--功能列表-->
        <Menulist :menulist="menulist"></Menulist>
        <!--功能列表_RWD-->
        <Menulist_RWD :menulist="menulist"></Menulist_RWD>
        <main class="main">
            <!--網站路徑(麵包屑)-->
            <Sitebar :sider="sider" ></Sitebar>
            <div class="incontall inconbox">
                <SideLeft_List :sideleft="sideleft"></SideLeft_List>
                <SideRight_FAQ :sideright="sideright"></SideRight_FAQ>
            </div>
        </main>
        <!--頁尾-->
        <Footer :footer="footer"></Footer>
        <GoTop></GoTop>
    </div>
</template>
<script>
import Header from '../../components/default_en/NavBar/Header.vue';
import Menulist from '../../components/default_en/NavBar/Menulist.vue';
import Menulist_RWD from '../../components/default_en/NavBar/Menulist_RWD.vue';
import Sitebar from '../../components/default_en/NavBar/Sitebar.vue';
import SideLeft_List from '../../components/default_en/Content/SideLeft_List.vue'
import SideRight_FAQ from '../../components/default_en/Content/SideRight_FAQ.vue';
import Footer from '../../components/default_en/NavBar/Footer.vue';
import GoTop from '../../components/default_en/Tool/GoTop.vue';

export default{
    components:{
        Header,
        Menulist,
        Menulist_RWD,
        Sitebar,
        SideLeft_List,
        SideRight_FAQ,
        Footer,
        GoTop,
    },
    data(){
        return {
            //首頁
            header:{
                text1:"Department of Bio-Industry Communication and Development",
                text2:"About",
                text3:"FAQ",
                
            },
            //功能列表 &功能列表_RWD
            menulist:{
                place:"About",
            },
            //網站路徑(麵包屑)
            sider:{
                index:2,
                type:0,
                list:[
                    {text:"About",url:"#",selected:true},
                    {text:"Regulations",url:"#",selected:false},
                ],
            },
            //左側資料(列表)
            //TODO 動態加入資料
            sideleft:{
                title:"About",
                list:[],
            },
            sideright:{
                table_Class:"faq",
                list_Class:"faqbox",
                list:[],
            },
            //頁尾
            footer:{

            },
            //頁碼
            pagination: {
                perPage: 10,
                page: 1,
                rows: 5,
            },
            //類別編號
            PJ_ID:"",
            //文章編號,
            type_id:"1",
            //文章類型
            modal:"1",
            //語言
            langurage:"2",
        }
    },
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        "$route.query"(){
            //初始化
            this.init();
        },
        "sideleft.list"(){
            //取得目前文章列表資訊
            this.getList();
        }
    },
    methods:{
        //初始化
        init(){
            //讀取query參數
            if( this.$route.query){
                //目前頁面編號
                this.PJ_ID = this.$route.query.PJ_ID? this.$route.query.PJ_ID:"";
                //語言
                this.langurage = this.$route.query.lang? this.$route.query.lang: "2";
                //目前頁面類型
                this.modal = this.$route.query.modal? this.$route.query.modal:"2";
            }
            
            //取得目前頁面資訊
            this.getHeader();
        },
        //取得目前頁面資訊
        async getHeader(){
            try{
                //POST參數
                let jsonReq ={
                    TYPE:"GetHeader_front",
                    about_type_SELECT:{
                        langurage :this.langurage,
                    },
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/AboutType",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    //匯入類別
                    let left_list = [];
                    jsonData.forEach((item ,index) => {
                        //若query沒有PJ_ID時，設定為第一個
                        if(this.PJ_ID =="" && index == 0){
                            this.PJ_ID = item.PJ_ID;
                        }
                        let list_item = {text:item.etitle, url:"About?PJ_ID="+item.PJ_ID + "&modal="+item.modal , selected:this.PJ_ID == item.PJ_ID };
                        left_list.push(list_item);
                        
                    });
                    this.sideleft.list = left_list;
                }
            }catch(err){
                console.log("ErrFunction: getHeader/n "+err);
            }
        },
        //取得目前文章列表資訊
        async getList(){
            try{
                //POST參數
                let jsonReq ={
                    TYPE:"HOME_LIST",
                    FAQ_SELECT:{
                        typeId: this.type_id,
                        langurage: this.langurage,
                        pageIndex: this.pagination.page,
                        pageSize: this.pagination.perPage,
                    }
                };
                //Token
                let resToken = await this.userRequest.post('bicd/Token');
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/FAQ",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if (json.Status){
                    let list = [];

                    let jsonData = JSON.parse(json.Data);
                    if (jsonData.outData.length > 0) {
                        jsonData.outData.forEach((x, i) => {
                            let obj = {
                                qnum: i+1,
                                title: x.title,
                                ans: x.description,
                            };
                            list.push(obj);
                        });
                    }else{
                         let obj = {
                            qnum: 0,
                            title: "",
                            ans: "",
                        }
                        list.push(obj);
                    }
                    this.sideright.list = list;
                }
            }catch(err){
                console.log("ErrFunction: getList/n " + err);
            }
        },
    },
}

</script>